import { trim } from "lodash";

import * as actions from "./actions";
import * as types from "./types";

import { apiCall, fetchImage, ORGANIZATION_AUTH_URL, TAG_LIST_URL } from "apis";
import { OrganizationDeserializer } from "serializers";

import { createError as baseCreateError } from "state/modules/error";

export const addDivisions = actions.addDivisions;

export const setOrganizationSlug = slug => dispatch => {
  dispatch(actions.setOrganizationSlug(trim(slug)));
};

export const getOrganization = slug => async dispatch => {
  await dispatch(
    apiCall({
      type: types.GET_ORGANIZATION,
      payload: {
        url: ORGANIZATION_AUTH_URL(slug),
        onSuccess: setOrganization,
        transform: OrganizationDeserializer,
        onError,
      },
    }),
  );
};

export const getOrganizationResponsibleUsers = questionnaire_id => async dispatch => {
  await dispatch(
    apiCall({
      type: types.GET_RESPONSIBLE_USERS,
      payload: {
        url: TAG_LIST_URL(questionnaire_id),
        onSuccess: responsibleUsers =>
          dispatch(actions.setOrganizationResponsibleUsers(responsibleUsers)),
        onError: _ => dispatch => {},
      },
    }),
  );
};

export const setFeedbackAssignee = assignee_id => dispatch => {
  dispatch(actions.setFeedbackAssignee(assignee_id));
};

const onError = error => dispatch => {
  if (error && error.status === 404) {
    dispatch(createError("Not found."));
    return;
  }
  dispatch(createError("Network not available."));
};

export const setOrganization = organization => async dispatch => {
  await Promise.all([
    dispatch(
      fetchImage({
        type: types.GET_BACKGROUND_IMAGE,
        payload: {
          url: organization.background,
          onSuccess: image => dispatch(actions.setBackground(image)),
        },
      }),
    ),
    dispatch(
      fetchImage({
        type: types.GET_LOGO_IMAGE,
        payload: {
          url: organization.logo,
          onSuccess: image => dispatch(actions.setLogo(image)),
        },
      }),
    ),
  ])
    .then(() => dispatch(actions.setOrganization(organization)))
    .catch(() => dispatch(createError("Network not available.")));
};

const createError = message => dispatch => {
  dispatch(
    baseCreateError({
      type: types.GET_ORGANIZATION,
      message,
    }),
  );
};
